module.exports = __webpack_public_path__ + "img/hk_mo_permit.fcd713e6.png";